import DefaultImage from "../../assets/Images/BrandImage1.png";

type Props = {
  magnetImage: string;
  magnetName: string;
  onClick: () => void;
};
function BrandPublicProfileMagnetCard({ magnetImage, magnetName, onClick }: Props) {
  return (
    <div role="button" tabIndex={0} className="text-primary-btn flex cursor-pointer flex-col" onClick={onClick}>
      <div className="my-auto">
        <img
          src={magnetImage || DefaultImage}
          alt={magnetName}
          className="aspect-1 w-full rounded-[4px] border border-white border-opacity-30
           object-cover object-center md:duration-500 md:ease-in-out md:hover:scale-105"
        />
      </div>
    </div>
  );
}

export default BrandPublicProfileMagnetCard;
